import React from 'react'

export const AuthLogo: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  className,
  alt = 'Code Ambassadors',
  ...props
}) => {
  return (
    <img
      src="/images/brand_logo.png"
      alt={alt}
      className={className}
      {...props}
    />
  )
}
